var $ = require('jquery');

var mmt,
	MainMenuTabbing = {
		settings: {},

		init: function () {
			mmt = this.settings;
			this.bindUIActions();
			console.log('MainMenuTabbing functionality loaded!');
		},

		bindUIActions: function () {
			// On window load or resize
			$(window).on('load resize', function () {
				// Remove any injected styles into sub-menu elements
				$('.main-menu > .menu-item > .sub-menu').attr('style', '');

				if ($(window).width() >= 1201) {
					$('header').removeClass('submenu-expanded').blur();
				}
			});

			window.addEventListener('load', function () {
				const header = $('header');
				// const mainMenu = $(".main-menu");
				const mainMenuItemsWithChildren = $('.main-menu > .menu-item-has-children');
				const submenuMenuItems = mainMenuItemsWithChildren.map((index, menuItem) => {
					return $(menuItem).find('.sub-menu > .menu-item');
				});

				//* Turn Off Feature on Mobile *//
				const windowWidth = $(window).width();
				if (windowWidth < 1080) return;

				const createSubmenuButton = function (index, menuItem) {
					var menuText = `Opens Menu, ${menuItem.innerText}`;
					var menuId =
						'submenu-' +
						menuText
							.replace(/[^a-z0-9\s-]/gi, '')
							.trim()
							.replace(/\s+/g, '-')
							.toLowerCase();
					$(menuItem).next().attr('id', menuId);
					$(menuItem).after(
						'<button class="expand-submenu-button" aria-label="' +
							menuText +
							' Menu" aria-controls="' +
							menuId +
							'" aria-expanded="false">^</button>'
					);
				};

				const toggleSubmenuExpanded = function (event) {
					const findExpandButton = (item) => {
						if (item.hasClass('expand-submenu-button')) return item;
						if (item.length <= 0) return false;

						return item.parent().siblings('.expand-submenu-button').length > 0
							? item.parent().siblings('.expand-submenu-button')
							: findExpandButton(item.parent());
					};

					const alreadyExpandedButtons = $(
						'.expand-submenu-button[aria-expanded="true"]'
					);

					const expandButton = findExpandButton($(event.target));

					const parentMenuItem = expandButton.parent();

					const removeExpanded = () => {
						header.removeClass('submenu-expanded');
						parentMenuItem.removeClass('submenu-expanded');
						expandButton.attr('aria-expanded', 'false');
						alreadyExpandedButtons.attr('aria-expanded', 'false');
					};

					const addExpanded = () => {
						const allCurrentExpanded = $(
							"expand-submenu-button[aria-expanded='true']"
						);

						header.addClass('submenu-expanded');
						expandButton.attr('aria-expanded', 'true');
						parentMenuItem.addClass('submenu-expanded');

						// Removes all other expanded menus
						allCurrentExpanded.each(function (index, button) {
							$(button).attr('aria-expanded', 'false');
							$(button).parent().removeClass('submenu-expanded');
						});
					};

					// If the expand button that was clicked is already expanded, then close the menu.
					if (expandButton.attr('aria-expanded') === 'true') {
						removeExpanded();
					}
					// If the expand button that was clicked is not already expanded, then close the menu and open the clicked menu.
					else {
						addExpanded();
					}

					return {expandButton, parentMenuItem};
				};

				// When the last menu item is focused and the tab key is pressed, it should close the menu.
				const closeSubmenuByLast = function (event) {
					// if not tab key or is shift key do nothing
					if (event.shiftKey || event.which !== 9) return;
					console.log('closeSubmenuByLast', event);
					event.preventDefault();
					const {expandButton} = toggleSubmenuExpanded(event);
					event.target.blur();
					expandButton.parent().next().children('a').focus();
				};

				const closeSubmenuByFirst = function (event) {
					// If 'tab key' and 'shift key' are pressed
					if (event.which === 9 && event.shiftKey) {
						event.preventDefault();
						console.log('closeSubmenuByFirst', event);
						const {expandButton} = toggleSubmenuExpanded(event);
						event.target.blur();
						expandButton.focus();
					}
				};

				// If a menu item has children (or a sub-menu), inject an "expansion arrow" for accessibility after the link in the menu item's link.
				$('.main-menu > .menu-item-has-children > a').each(createSubmenuButton);

				// When interacted with (clicked)
				$('.expand-submenu-button').on('click', toggleSubmenuExpanded);

				submenuMenuItems.each(function (index, menuItem) {
					menuItem.children().first().on('keydown', closeSubmenuByFirst);
					console.log(
						'🚀 ~ file: mainMenuTabber.js:140 ~ menuItem.children().first():',
						menuItem.children().first()
					);
					menuItem.last().on('keydown', closeSubmenuByLast);
				});

				// $(
				// 	".main-menu > .menu-item > .sub-menu > .menu-item:last-of-type > .sub-menu"
				// ).length > 0
				// 	? $(
				// 			".main-menu > .menu-item > .sub-menu > .menu-item:last-of-type > .sub-menu > .menu-item:last-of-type > a"
				// 	  ).on("keydown", closeSubmenuByLast)
				// 	: $(
				// 			".main-menu > .menu-item > .sub-menu > .menu-item:last-of-type > a"
				// 	  ).on("keydown", closeSubmenuByLast);

				// // When the first menu item is focused and the shift and tab keys are pressed together, it should close the menu.
				// $(
				// 	".main-menu > .menu-item > .sub-menu > .menu-item:first-of-type > a"
				// ).on("keydown", closeSubmenuByFirst);
			});
		}
	};

module.exports = MainMenuTabbing;
